export default __webpack_public_path__ + "static/media/footballicon.76e39abc.png";